import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CloseWorkOrderInput, ClosedWorkOrder } from "../type/WorkOrder";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { GET_WORK_ORDERS_FETCH_KEY } from "./useGetWorkOrder";

export const updateCloseWorkOrder = async (
  closedWorkOrderId: string,
  data: CloseWorkOrderInput,
): Promise<ClosedWorkOrder> => {
  const response = await fetcher.put<ClosedWorkOrder>(
    `${API.GESLUB}/workOrders/${closedWorkOrderId}/close`,
    data,
  );
  return response.data;
};

export const useUpdateCloseWorkOrder = () => {
  const queryClient = useQueryClient();

  return useMutation<
    ClosedWorkOrder,
    Error,
    { closedWorkOrderId: string; data: CloseWorkOrderInput }
  >({
    mutationFn: ({ closedWorkOrderId, data }) =>
      updateCloseWorkOrder(closedWorkOrderId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_WORK_ORDERS_FETCH_KEY],
      });
    },
  });
};
